import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Popover } from '@material-ui/core';
import { CustomDeleteModal } from '../../fragments';
import { EditDocumentNew } from './editDocumentNew';
import { MinLoader } from '../loader';
import { httpRequestsOnSuccessActions } from '../../store';
import {
  Colors,
  DownloadFile,
  FindSuccess,
  Images,
  PermissionsList,
  RolePermission,
  useModal,
} from 'utils';

export const DocumentSettings = (
  {
    document,
    docTypes,
    handleDeleteDocument,
    permissionForDelete,
    deleteDocAction,
    handleChangeStatus,
    changeStatusAction,
    customFile,
    dontAllowAddDocument,
    downloadAccess = true,
    deleteAccess = false,
    viewAccess,
    handleEdit,
    dontChangeType,
  }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const { open, close } = useModal();
  const success = FindSuccess(changeStatusAction);
  const openPopover = Boolean(anchorEl);
  const id = openPopover ? 'simple-popover' : undefined;
  const { loadDownload, handleDownload, handleDownloadAnotherUrl } = DownloadFile();

  const toggleSettings = (event) => {
    setAnchorEl(event ? event.currentTarget : null);
  };

  useEffect(() => {
    if (success?.length) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(changeStatusAction));
      toggleSettings();
      close();
    }
  }, [success]);

  const download = async () => {
    if (customFile) {
      await handleDownloadAnotherUrl(document);
    } else {
      await handleDownload(document);
    }
  };

  return (
    <div className="document-settings-wrapper">
      <button
        className="document-settings-button"
        onClick={toggleSettings}
      >
        <img src={Images.more} alt="icon" />
      </button>

      <Popover
        id={id}
        open={openPopover}
        anchorEl={anchorEl}
        onClose={() => toggleSettings()}
        className="document-settings-popover-wrapper"
        classes={{
          paper: 'document-settings-popper',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className="document-settings-popper-wrapper">
          <div className="document-settings-popper-actions-wrapper">
            {(handleChangeStatus && !dontAllowAddDocument) &&
              <div
                className="document-settings-popper-actions-item"
                onClick={() => {
                  toggleSettings();
                  open(
                    <EditDocumentNew
                      docTypes={docTypes}
                      actionType={changeStatusAction}
                      info={document}
                      handleEdit={handleChangeStatus}
                      dontChangeType={dontChangeType}
                    />);
                }
                }
              >
                <div className="document-settings-popper-actions-img">
                  <img src={Images.edit} alt="edit" />
                </div>

                <p className="document-settings-popper-text">Edit</p>
              </div>
            }

            {(handleEdit) &&
              <div
                className="document-settings-popper-actions-item"
                onClick={(e) => {
                  toggleSettings();
                  handleEdit(e);
                }
                }
              >
                <div className="document-settings-popper-actions-img">
                  <img src={Images.edit} alt="edit" />
                </div>

                <p className="document-settings-popper-text">Edit</p>
              </div>
            }


            {(viewAccess) &&
              <a
                className="document-settings-popper-actions-item"
                href={document?.file?.url}
                target="_blank"
              >
                <div className="document-settings-popper-actions-img">
                  <img src={Images.eyeSvg} alt="edit" />
                </div>

                <p className="document-settings-popper-text">View</p>
              </a>
            }

            {downloadAccess &&
              <div
                className="document-settings-popper-actions-item"
                onClick={download}
              >
                <div className="document-settings-popper-actions-img">
                  {loadDownload ?
                    <MinLoader
                      margin={'0'}
                      style={{ height: '100%', width: '100%' }}
                      position={'relative'}
                      color={Colors.ThemeGreen}
                    />
                    :
                    <img src={Images.download} alt="download" />
                  }
                </div>
                <p className="document-settings-popper-text">Download</p>
              </div>
            }

            {(
                handleDeleteDocument
                &&
                (
                  RolePermission(permissionForDelete ? [PermissionsList.ALL_ACCESS?.code, permissionForDelete] : [PermissionsList.ALL_ACCESS?.code])
                )
              )
              &&
              <div
                className="document-settings-popper-actions-item"
                onClick={() => {
                  toggleSettings();
                  open(
                    <CustomDeleteModal
                      actionType={deleteDocAction}
                      text="Delete File?"
                      info={document?.name}
                      handleDel={() => handleDeleteDocument(document)}
                      afterSuccess={() => close()}
                    />);
                }}
              >
                <div className="document-settings-popper-actions-img">
                  <img src={Images.trashIcon} alt="delete" />
                </div>

                <p className="document-settings-popper-text">Delete</p>
              </div>
            }
          </div>
        </div>
      </Popover>
    </div>
  );
};

